import { MaintenanceResponse } from '../data-types/initialisation/initialisationInterfaces';
import { maintenanceCheck } from '../socket-types/maintenanceSocketTypes';
import { setMaintenance } from '../state/actions/customizationActions';
import { sendCommand } from './commandsHandler';

export const checkMaintenanceStatus = async () => {
  try {
    const response = await sendCommand<MaintenanceResponse>(maintenanceCheck, {});

    setMaintenance(response.data.maintenanceMode);
  } catch (e) {
    setMaintenance(false);
  }
};
